webpackJsonp([10],{

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
if (window.innerWidth > 639) {
	mc.runVue(['Slider', 'Navigation', 'selectList']);
} else {
	var components = document.querySelectorAll('[is]');
	var lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
		$(entries).each(function (index, entry) {
			// console.log(entry);
			if (window.Vue) lazyBackgroundObserver = null;
			if (entry.isIntersecting) {
				if (entry.target.getAttribute('is') === 'Navigation') {
					$(entry.target).on('click', function (e) {
						e.currentTarget.classList.add('open');
						mc.runVue(['Slider', 'Navigation', 'selectList']);
					}.bind(this));
					return;
				};
				mc.runVue(['Slider', 'Navigation', 'selectList']);
			}
		});
	});
	$(Array.from(components)).each(function (i, lazyBackground) {
		lazyBackgroundObserver.observe(lazyBackground);
	});
}
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[58]);


// WEBPACK FOOTER //
// bundles/news-detail.bundle.js